var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import get from "lodash/get";
import PlainComponent from '../../components/plain/PlainComponent';
import { generateComponentKey } from '../utils';
export function render(node, path) {
    if (!node.Content)
        return null;
    var _a = node.Content, props = _a.props, label = _a.label;
    var componentKey = get(node, 'Content.props.componentKey', get(node, 'Content.componentKey', generateComponentKey(path, label)));
    return (_jsxs(PlainComponent, { componentKey: componentKey, children: [React.createElement('span', __assign({}, props), label), ' '] }, componentKey));
}
